import React from "react";
import { Link } from "react-router-dom";

export default function Footer({ onFilterChange, onNavigateCatalog }) {
  return (
    <footer className="rodape">
      <div className="rodape-inner">
        <div className="rodape-marca">
          <div
            className="logo-repique"
            onClick={() => onNavigateCatalog("todos")}
            style={{ cursor: "pointer" }}
          >
            <div>
              <span className="logo-texto">Repique</span>
              <span className="logo-subtitulo">
                Esporas, Cuias, Bombas e outros
              </span>
            </div>
          </div>
          <p>
            Artigos gaúchos de alta qualidade. Cada peça é única e selecionada.
          </p>
        </div>

        <div>
          <p className="rodape-titulo">Categorias</p>
          <ul className="rodape-lista">
            <li>
              <Link to="/produtos?categoria=esporas">Esporas</Link>
            </li>
            <li>
              <Link to="/produtos?categoria=bombas">Bombas</Link>
            </li>
            <li>
              <Link to="/produtos?categoria=cuias">Cuias</Link>
            </li>
            <li>
              <Link to="/produtos">Ver Todos</Link>
            </li>
          </ul>
        </div>

        <div>
          <p className="rodape-titulo">Atendimento</p>
          <ul className="rodape-lista">
            <li>Pedidos via WhatsApp</li>
          </ul>
        </div>
      </div>
      <div className="rodape-linha">
        <span className="rodape-copyright">
          © 2026 Repique Esporas — Todos os direitos reservados
        </span>
        <span className="rodape-copyright">Feito com tradição</span>
      </div>
    </footer>
  );
}
